import React, { useState, useEffect } from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import axios from 'axios';
import TopImage from "../components/common/TopImage";

const baseURL = process.env.PUBLIC_URL + '/assets/';

const ContactUsPage = () => {
  return (
    <div className="mt-20">
      <NavBar />
      <TopImage text="Contact Us"/>
      <div className="flex flex-col items-center justify-center p-8 mt-12 text-4xl font-bold text-red capitalize">
        {/* Contact Us */}
      </div>
      <div className="mx-5 md:mx-10 lg:mx-20 xl:mx-28 mb-20 max-md:mb-8">
        <MyComponent />
        <Maps />
      </div>
      <Footer />
    </div>
  );
};

function MyComponent(props) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Invalid email format';
    }
    if (!formData.phone.trim()) {
      errors.phone = 'Telephone is required';
    } else if (!/^[0-9\b]+$/.test(formData.phone)) {
      errors.phone = 'Telephone must contain only numbers';
    } else if (formData.phone.length !== 10) {
      errors.telephone = 'Telephone must have 10 digits';
    }
    if (!formData.message.trim()) {
      errors.message = 'Message is required';
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
    } else {
      try {
        await axios.post('http://localhost:5000/send-email', formData);
        setIsSubmitted(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } catch (err) {
        console.error(err);
        alert('Failed to send message. Please try again later.');
      }
    }
  };

  return (
    <div className="flex flex-col max-md:flex-row">
      {window.innerWidth > 576 && (
        <div className="flex gap-5 justify-between px-5 max-md:px-0 w-full text-4xl font-bold tracking-wider text-center text-black max-md:flex-wrap max-md:max-w-full">
          <div className="flex-col">Contact Details</div>
          <div className="flex-auto max-md:max-w-full">Connect With Us</div>
        </div>
      )}
      <div className=" w-full max-md:mt-10 max-md:max-w-full">
        {window.innerWidth<576 &&(
      <div className=" text-4xl font-bold text-red capitalize text-center">Contact Details</div>
        )}
      <div className="flex gap-5 justify-between mt-6 max-md:flex-col max-md:gap-0">
        <div className="flex flex-col w-[46%] max-md:ml-0 max-md:w-full">
          <div className="flex  justify-between text-xl font-medium tracking-wide max-md:mt-10">
            <div className="flex flex-col self-start px-5 text-justify font-medium basis-0 text-black">
              <div className="whitespace-nowrap">Email Id</div>
              <div className="mt-6 whitespace-nowrap">Phone No</div>
              <br/>
              <div className="mt-12">Tel No </div>
              <div className="mt-6">Location </div>
            </div>
            <div className="flex flex-col flex-1 px-5 text-stone-900">
              <div className="text-justify text-wrap">mcatonk@gmail.com</div>
              <div className="mt-6 text-justify">+91-8239945863 <br/>+91-8209549018 <br/>+91-‪6376147129‬</div>
              
              <div className="mt-5">01432-244097</div>
              <div className="mt-6">
                Punch Kuiya Darwaza, Purani Tonk, Tonk, Rajasthan, 304001
              </div>
            </div>
          </div>
        </div>
        {window.innerWidth <576 && (
        <div className=" flex-auto mt-12 text-4xl font-bold text-red capitalize text-center">Connect With Us</div>
        )}
          <div className="flex flex-col ml-5 w-[54%] shadow-[rgba(50,50,93,0.25)0px_6px_12px-2px,rgba(0,0,0,0.3)_0px_3px_7px-3px]  max-md:ml-0 max-md:w-full">
            {!isSubmitted ? (
              <div className="flex flex-col bg-admission-color grow justify-end px-10 pt-0 pb-20 w-full text-base tracking-wider text-center capitalize whitespace-nowrap rounded-3xl shadow-lg text-neutral-400 max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <div className="justify-center items-start py-4 pr-16 pl-6 mt-20 rounded-xl bg-zinc-50 border border-solid border-gray-500 max-md:px-5 max-md:max-w-full">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                    className="w-full py-2 px-3 rounded-md text-black bg-zinc-50 border-zinc-300 placeholder-gray-400 focus:outline-none"
                    style={{ fontSize: "1.2rem" }}
                  />
                </div>
                <div>{errors.name && <span className="error">{errors.name}</span>}</div>
                <div className="flex gap-5 justify-between mt-5 max-md:flex-wrap max-md:max-w-full">
                  <div className="grow justify-center items-start py-3.5 pr-16 pl-6 rounded-xl bg-zinc-50 border border-solid border-gray-500 max-md:px-5">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email id"
                      className="w-full py-2 px-3 rounded-md text-black bg-zinc-50 border-zinc-300 placeholder-gray-400 focus:outline-none"
                      style={{ fontSize: "1.2rem" }}
                    />
                  </div>
                  <div className="grow justify-center items-start py-3.5 pr-16 pl-6 rounded-xl bg-zinc-50 border border-solid border-gray-500 max-md:px-5">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Phone No."
                      className="w-full py-2 px-3 text-white-100 rounded-md text-black bg-zinc-50 border-zinc-300 placeholder-gray-400 focus:outline-none"
                      style={{ fontSize: "1.2rem" }}  
                    />
                  </div>
                </div>
                <div>
                  <div>
                    {errors.email && <span className="error">{errors.email}</span>}
                  </div>
                  <div>
                    {errors.phone && <span className="error">{errors.phone}</span>}
                  </div>
                </div>
                <div className="items-start p-1 mt-5 bg-zinc-50 rounded-xl border border-gray-500 border-solid max-md:px-5 max-md:pb-10">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Message"
                    className="w-full h-32 p-4 pl-8 rounded-md bg-zinc-50 text-black border-zinc-300 placeholder-gray-400 focus:outline-none max-md:pl-3"
                    style={{ fontSize: "1.2rem" }}
                  />
                </div>
                <div>
                  {errors.message && <span className="error">{errors.message}</span>}
                </div>
                <div
                  className="justify-center self-start px-8 py-2.5 mt-7 font-medium text-white bg-blue-400 rounded-xl shadow-md max-md:px-5"
                  onClick={handleSubmit}
                >
                  Submit
                </div>
              </div>
            ) : (
              <p>Form submitted successfully!</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const Maps = (props) => {
  const [pageWidth, setPageWidth] = useState(2000);

  useEffect(() => {
    const updatePageWidth = () => {
      setPageWidth(window.innerWidth);
    };

    updatePageWidth();

    window.addEventListener("resize", updatePageWidth);

    return () => {
      window.removeEventListener("resize", updatePageWidth);
    };
  }, []);

  return (
    <div className="flex flex-col px-5 text-4xl font-medium tracking-wider text-justify text-black capitalize whitespace-nowrap">
      <div className="max-md:ml-2.5">
        <p className="font-bold mt-20 text-center">How to reach us?</p>
      </div>
      <a href="https://maps.app.goo.gl/XVBWqLeWyKBWrKST9?g_st=iw" target="_blank">
        <img
          loading="lazy"
          src={`${baseURL}/Map.jpeg`}         
          className="mt-16 w-full aspect-[2.86] border-2 border-solid border-black max-md:mt-10 max-md:max-w-full"
          alt="How to reach us"
        />
      </a>
    </div>
  );
};

export default ContactUsPage;

